import type { ItineraryLeg } from "./itinerary";

export type TrailVisits = [string, number][];
export const MAX_VISITED_TRAILS = 400;

export function validTrailVisits(value: unknown): value is TrailVisits {
  return Array.isArray(value) && value.length <= MAX_VISITED_TRAILS
    && value.every(entry => Array.isArray(entry) && entry.length === 2
      && typeof entry[0] === "string" && entry[0].length > 0 && entry[0].length <= 200
      && Number.isInteger(entry[1]) && entry[1] >= 1 && entry[1] <= 400)
    && new Set(value.map(entry => entry[0])).size === value.length;
}

/** Count a contiguous mapped run once, independently of its graph segments. */
export function visitsAfter(legs: readonly ItineraryLeg[], initial: ReadonlyMap<string, number> = new Map()): Map<string, number> {
  const visits = new Map(initial);
  let previous: string | null = null;
  for (const leg of legs) {
    const id = leg.kind === "trail" && !leg.climb ? leg.refId : null;
    if (id && id !== previous) visits.set(id, Math.min(400, (visits.get(id) ?? 0) + 1));
    previous = id;
  }
  return new Map([...visits].slice(-MAX_VISITED_TRAILS));
}

/** Session counts already include completed route steps: merge without doubling. */
export function mergeVisits(a: ReadonlyMap<string, number>, b: ReadonlyMap<string, number>): Map<string, number> {
  const result = new Map(a);
  for (const [id, count] of b) result.set(id, Math.max(count, result.get(id) ?? 0));
  return new Map([...result].slice(-MAX_VISITED_TRAILS));
}
